var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { CircleCheck, MessageSquareDot } from '@codegrade/icons';
import { Icon } from '@/components/Icon';
import * as models from '@/models';
import { AssignmentsStore, NotificationStore, SubmissionsStore } from '@/store';
import * as utils from '@/utils';
let UserNotification = class UserNotification extends Vue {
    /** The notification to render. */
    notification;
    /** @returns A set of icons used by the component. */
    get icons() {
        return {
            MessageSquareDot,
            CircleCheck,
        };
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    get submission() {
        return this.notification.submission;
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    get assignment() {
        return this.notification.assignment;
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    get loading() {
        return this.assignment.isNothing() || this.submission.isNothing();
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    get feedbackType() {
        const { type } = this.notification;
        switch (type) {
            case 'general_comment_notification':
                return 'a general';
            case 'comment_notification':
                return 'an inline';
            default:
                throw utils.AssertionError.assertNever(type);
        }
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    submitting;
    /** Create this class. */
    constructor() {
        super();
        this.submitting = false;
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    onNewNotification() {
        this.submitting = false;
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    markAsRead() {
        this.submitting = true;
        return this.notification.markAsRead();
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    afterSubmit() {
        this.submitting = false;
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    get whyNotification() {
        const me = models.NormalUser.getCurrentUser();
        return this.submission.mapOrDefault(sub => {
            const author = sub.user;
            const assignee = sub.assignee;
            if (me.isEqualOrMemberOf(author)) {
                if (author?.isGroup) {
                    return 'one of the authors of the submission';
                }
                else {
                    return 'author of the submission';
                }
            }
            else if (assignee.mapOrDefault(a => me.isEqualOrMemberOf(a), false)) {
                return 'the assignee of the submission';
            }
            else {
                return '';
            }
        }, '');
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    get assignmentToLink() {
        return this.assignment.mapOrDefault(assignment => ({
            name: 'assignment_submissions',
            params: {
                courseId: assignment.courseId,
                assignmentId: assignment.id,
            },
            query: {},
            hash: undefined,
        }), undefined);
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    onVisible(isVisible) {
        if (this.loading && isVisible) {
            utils.loadBackgroundPromises(SubmissionsStore.loadSingleSubmission({
                assignmentId: this.notification.assignmentId,
                submissionId: this.notification.submissionId,
            }), AssignmentsStore.loadSingleAssignment({
                assignmentId: this.notification.assignmentId,
            }));
        }
    }
    /* eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation. */
    afterDismmissNotification(result) {
        this.submitting = false;
        NotificationStore.commitUpdateNotifications({ notifications: [result.cgResult] });
    }
    /* eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation. */
    capitalize(text) {
        return utils.capitalize(text);
    }
};
__decorate([
    Prop({ required: true })
], UserNotification.prototype, "notification", void 0);
__decorate([
    Watch('notification')
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
], UserNotification.prototype, "onNewNotification", null);
UserNotification = __decorate([
    Component({
        components: {
            Icon,
        },
    })
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
], UserNotification);
export default UserNotification;
